import React, { useRef, useCallback } from "react";
import { useTranslation } from "react-i18next";
import { filteredRow } from "../../../utils/dataTransformer";
import AgGrid from "../../Table/AgGrid";

const PurchasePermission = ({ columnDefs, priviledgeList, resource }) => {
  const gridRef = useRef();
  const { t } = useTranslation();

  const useFilteredRows = useCallback(() => {
    const rows = [
      {
        functionName: "REQUEST",
        name: t("purchase.request.index"),
        view: "view",
        create: "create",
        edit: "edit",
        cancel: "cancel",
      },
      {
        functionName: "ORDER",
        name: t("purchase.order.index"),
        view: "view",
        create: "create",
        edit: "edit",
        cancel: "cancel",
      },
      {
        functionName: "RETURN",
        name: t("purchase.return.index"),
        view: "view",
        create: "create",
        edit: "edit",
        cancel: "cancel",
      },
      {
        functionName: "REPORT",
        name: t("report"),
        view: "view",
      },
    ];
    return filteredRow(rows, priviledgeList, resource);
  }, [priviledgeList, resource, t]);

  return (
    <AgGrid
      rowData={useFilteredRows()}
      ref={gridRef}
      columnDefs={columnDefs}
      autoHeight
      isClientSide
    />
  );
};

export default PurchasePermission;
